'use client';

import { Typography } from '@workspace/ui/common';
import { typographyVariants } from '@workspace/ui/common/Typography/typography.variants';
import type { MiddleBannerProps } from './middle-banner.types';
import { processHeading, mapHeadingVariant } from '@workspace/lib/heading-utils';
import { cn } from '@workspace/lib';
import { getBackgroundClass } from '@workspace/lib';
import { CustomPortableText } from '@workspace/ui/PortableText';
import { getAlignmentClass } from './layout';
import { renderButton } from './renderButton.ui';

export function MiddleBanner({ block }: MiddleBannerProps) {
  const {
    isActive = true,
    backgroundColor,
    heading,
    headingAlignment = 'text-center',
    subheading,
    subheadingAlignment = 'text-center',
    bodyContent,
    bodyAlignment = 'text-center',
    buttonOptional,
  } = block;

  const { text: headingText } = processHeading(heading);
  const headingVariant = mapHeadingVariant(heading, 'h2');
  const headingFontClass = typographyVariants({ variant: headingVariant });

  if (isActive === false) return null;

  const backgroundClass = getBackgroundClass(backgroundColor);

  return (
    <div className={cn('background-container', backgroundClass)}>
      <div className="porta-container">
        <div className="w-full md:py-3xl pb-20  md:px-md-banner py-xl px-md">
          <div className="text-container space-y-4">
            {headingText && (
              <Typography
                variant="h2"
                className={cn(headingFontClass, 'font-bold text-primary', getAlignmentClass(headingAlignment))}
              >
                {headingText}
              </Typography>
            )}
            {subheading && (
              <Typography
                variant="h3"
                className={cn('font-bold', getAlignmentClass(subheadingAlignment))}
                styleVariant="h5"
              >
                {subheading}
              </Typography>
            )}
          </div>

          {bodyContent && bodyContent.length > 0 && (
            <div className={cn('mt-8', getAlignmentClass(bodyAlignment))}>
              <CustomPortableText value={bodyContent} className="prose prose-lg max-w-none" />
            </div>
          )}

          {buttonOptional && <div className="mt-8 flex justify-center w-full">{renderButton(buttonOptional)}</div>}
        </div>
      </div>
    </div>
  );
}
